import { RefObject } from 'react';
import { FocusedImage } from 'image-focus';

// Adds focus to an image based on x and y coordinates
const focusedImage = (
  imageRef: RefObject<HTMLImageElement>,
  focalPointX: number,
  focalPointY: number
): FocusedImage | undefined => {
  let focusedImage;
  if (imageRef?.current) {
    focusedImage = new FocusedImage(imageRef.current, {
      focus: {
        x: focalPointX,
        y: focalPointY,
      },
      containerPosition: 'absolute',
    });
  }

  return focusedImage;
};

export default focusedImage;
